import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
// @ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import produce from 'immer';

import * as constants from './constants';
import { ASSIGNMENT_STATES, LessonAssignmentActions, LessonAssignmentStore } from './typings';

export const initialState: LessonAssignmentStore = {
    assignmentState: ASSIGNMENT_STATES.IDLE,
    lessonMode: CLESSON_MODES.LESSON,
    currentAccordionItem: null,
    assignDate: null,
    deadlineDate: null,
    assignDateError: null,
    deadlineDateError: null,
    duration: null,
    durationError: null,
    selectedStudents: [],
    studentsError: null,
    externalLmsAvailableDatesLoadingStatus: LOADING_STATUSES.UNSENT,
    externalLmsAvailableDates: null,
    externalLmsDatesError: null,
};

const assignLessonModalReducer = (state: LessonAssignmentStore = initialState, action: LessonAssignmentActions) => {
    // eslint-disable-next-line consistent-return,complexity
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.SET_ACCORDION_ITEM:
                draft.currentAccordionItem = action.accordionItem;
                break;

            case constants.SET_ASSIGNMENT_STATE:
                draft.assignmentState = action.assignmentState;
                break;

            case constants.SET_TO_DEFAULT:
                return initialState;

            case constants.SET_ASSIGN_DATE: {
                draft.assignDate = action.value;

                break;
            }

            case constants.SET_DEADLINE_DATE: {
                draft.deadlineDate = action.value;

                break;
            }

            case constants.SET_ASSIGN_DATE_ERROR: {
                draft.assignDateError = action.errorMessage;

                break;
            }

            case constants.SET_DEADLINE_DATE_ERROR: {
                draft.deadlineDateError = action.errorMessage;

                break;
            }

            case constants.SET_DURATION: {
                draft.duration = action.duration;

                break;
            }

            case constants.SET_DURATION_ERROR: {
                draft.durationError = action.errorMessage;

                break;
            }

            case constants.SET_LESSON_MODE:
                draft.lessonMode = action.lessonMode;

                break;

            case constants.SET_SELECTED_STUDENTS:
                draft.selectedStudents = action.studentsIds;
                break;

            case constants.SET_STUDENTS_ERROR:
                draft.studentsError = action.error;
                break;

            case constants.LOAD_EXTERNAL_LMS_AVAILABLE_DATES_REQUEST:
                draft.externalLmsAvailableDatesLoadingStatus = LOADING_STATUSES.LOADING;
                break;

            case constants.LOAD_EXTERNAL_LMS_AVAILABLE_DATES_SUCCESS:
                const { lesson_start_datetimes, lesson_finish_datetimes } = action.dates;

                draft.externalLmsAvailableDatesLoadingStatus = LOADING_STATUSES.SUCCESS;
                draft.externalLmsAvailableDates = {
                    lessonStartDatetimes: lesson_start_datetimes.map((date: string) => new Date(date)),
                    lessonFinishDatetimes: lesson_finish_datetimes.map((date: string) => new Date(date)),
                };
                break;

            case constants.LOAD_EXTERNAL_LMS_AVAILABLE_DATES_ERROR:
                draft.externalLmsAvailableDatesLoadingStatus = LOADING_STATUSES.ERROR;
                break;

            case constants.SET_EXTERNAL_LMS_DATES_ERROR: {
                draft.externalLmsDatesError = action.errorMessage;

                break;
            }

            default:
                break;
        }
    });
};

export default assignLessonModalReducer;
